<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5209 3.69999L15.3209 2.48334C15.2209 2.38334 15.1042 2.33334 14.9709 2.33334C14.8376 2.33334 14.7042 2.38334 14.6209 2.48334L7.63758 9.56667C7.58758 9.61667 7.55423 9.66667 7.5209 9.73334L6.73758 11.7167C6.67091 11.9 6.70424 12.1167 6.85424 12.25C6.95424 12.35 7.0709 12.4 7.20423 12.4C7.2709 12.4 7.32091 12.3833 7.38758 12.3667L9.35424 11.5833C9.4209 11.55 9.4709 11.5167 9.5209 11.4667L16.5042 4.38334C16.7209 4.20001 16.7209 3.88333 16.5209 3.69999ZM8.90424 10.7L8.10424 11.0167L8.42091 10.2L14.9709 3.55001L15.4709 4.05001L8.90424 10.7ZM14.0042 10.1V16.8333C14.0042 17.2 13.6709 17.5 13.3042 17.5H3.83757C3.47091 17.5 3.17091 17.2 3.17091 16.8333V4.13334C3.17091 3.76668 3.47091 3.5 3.83757 3.5H10.7709C11.1376 3.5 11.4376 3.8 11.4376 4.16667C11.4376 4.53334 11.1376 4.83334 10.7709 4.83334H4.50424V16.1667H12.6709V10.1C12.6709 9.73333 12.9709 9.43333 13.3376 9.43333C13.7042 9.43333 14.0042 9.73333 14.0042 10.1Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: "editIcon-2",
    props: {
      fill: {
        type: String,
        default: '#109CF1'
      }
    }
  }
</script>

<style scoped>

</style>
